import axios from "axios";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
  Tooltip,
} from "reactstrap";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import LoadingData from "../TESTPage/LoadingData";
import FadeIn from "react-fade-in/lib/FadeIn";
import { fullMonthNames } from "../../common/data/monthName";
import { ConvertDate } from "../Function/ConvertDate";
import { useNavigate } from "react-router-dom";
import { CheckBudgetYear } from "../Function/CheckBudgetYear";
import { ChunkArray } from "../Function/ChunkArray";
import { useNavigatorState } from "../Context/NavigatorState";
import NewThaiDatePicker from "../../components/Common/NewThaiDatePicker";
import ConfirmModal from "../../components/Common/ConfirmModal";
import { useStaticPicker } from "@mui/x-date-pickers/internals";

const TimeHistoryTable = () => {
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;

  const { navigateState, setNavigateState } = useNavigatorState();

  const [timeHistory, setTimeHistory] = useState([]);
  const [entryHistory, setEntryHistory] = useState([]);
  const [outHistory, setOutHistory] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [monthSelect, setMonthSelect] = useState(new Date().getMonth());
  const [sortCount, setSortCount] = useState({
    date: 0,
  });
  const [searchData, setSearchData] = useState({
    fromDate: "",
    toDate: "",
  });
  const [chunkEntry, setChunkEntry] = useState([]);
  const [entryPagination, setEntryPagination] = useState({
    page: 1,
    totalRows: 0,
    totalPage: 0,
  });

  const checkMonthEntry = (monthselect = new Date().getMonth()) => {
    let year = new Date().getFullYear();
    let lastDayOfMonth = new Date(
      new Date()?.getFullYear(),
      monthselect + 1,
      0
    ).getDate();
    return new Date(year, monthselect, lastDayOfMonth);
  };

  const [startDate, setStartDate] = useState(new Date().setDate(new Date().getDate() - 30))
  const [toDate, setToDate] = useState(new Date())

  
  const [budgedYearOptions, setBudgedYearOptions] = useState([])  
  
  const [OTRemark, setOTRemark] = useState("")
  const [OTRemarkModal, setOTRemarkModal] = useState(false)
  const [fscanID, setFscanID] = useState()
  
  useEffect(() => {
    const generateYearsArray = () => {
      const years = [];
      for (let year = CheckBudgetYear(); year >= 2561; year--) {
        years.push(year);
      }
      setBudgedYearOptions(years);
    };
    generateYearsArray();
  }, []);

  const getEntryHistory = async (
    page = 1,
    size = 10000,
  ) => {
    try {
      setTimeHistory([]);
      setEntryHistory([]);
      setOutHistory([]);
      setChunkEntry([])
      setOTRemark("")
      setEntryPagination((prev) => ({
        ...prev,
        page: prev.page,
        totalRows: 0,
        totalPage: 0,
      }));
      const url = `${baseURL}/api/time/history`;
      const params = new URLSearchParams({
        page: page,
        size: size,
        "order[0]": "scan_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        // "filter[budget_year][0]": budgetYear,
        // "filter[entry_exit_status][0]": "0",
        // "filter[entry_exit_status][1]": "1",
        date_start: ConvertDate(startDate).toOnlyDate(),
        date_end: ConvertDate(toDate).toOnlyDate(),
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setTimeHistory(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };



  const timeHistoryEdit = async (id) => {//id ใช้เป็น fscan_id ของสถานะออกงาน
      try {
        const res = await axios.put(
          baseURL + `/api/fingerscanData/${id}`,
          {
            ot_remark : OTRemark
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } catch (err) {
        console.error(err);
      }
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
    }, 1200);
    checkMonthEntry(monthSelect);
    getEntryHistory(1, 1000);
  }, []);

  const setDataToEntryAndOut = () => {
    setEntryHistory([]);
    setOutHistory([]);
    timeHistory?.map((item) => {
      if (item?.entry_exit_status !== 1) {
        setEntryHistory((prev) => [...prev, item]);
      } else {
        setOutHistory((prev) => [...prev, item]);
      }
    });
  };

  useEffect(() => {
    if (timeHistory?.length > 0) {
      setDataToEntryAndOut();
    }
  }, [timeHistory]);

  useEffect(() => {
    if (entryHistory?.length > 0) {
      setChunkEntry(ChunkArray(entryHistory, 10));
      setEntryPagination((prev) => ({
        ...prev,
        page: prev.page,
        totalRows: entryHistory?.length,
        totalPage: ChunkArray(entryHistory, 10)?.length,
      }));
    }
  }, [entryHistory]);

  useEffect(() => {
    getEntryHistory(
      1,
      10000,
      // new Date(new Date().getFullYear(),parseInt(monthSelect),1),
      // checkMonthEntry(parseInt(monthSelect)),
    );
  }, [startDate,toDate]);

  const setSearchDate = (e) => {
    setStartDate(e)
    setToDate(e)
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Row className="d-flex align-items-center pb-2">
            <Label className="text-center pe-0 fs-5" xxl={2} sm={4}>
              ประวัติการเข้างาน
            </Label>
            <Col xxl={2} sm={8}>
              <NewThaiDatePicker name ={"date_start"} value={startDate} setValue={setSearchDate} placeholderText = "วัน/เดือน/ปี" showClearButton = {true}/>
              {/* <Input
                type="select"
                defaultValue={monthSelect}
                onChange={(e) => {
                  setMonthSelect(e.target.value);
                }}
              >
                {fullMonthNames?.map((item, idx) => {
                  return (
                    <option key={idx} value={idx}>
                      {item}
                    </option>
                  );
                })}
              </Input> */}
            </Col>
            <Label className="text-center px-0 fs-5" xxl={1} sm={4}>
              ถึงวันที่
            </Label>
            <Col xxl={2} sm={8}>
              <NewThaiDatePicker name ={"date_end"} value={toDate} minDate = {startDate} setValue={setToDate} placeholderText = "วัน/เดือน/ปี" showClearButton = {true}/>
              </Col>
            {/* <Label className="text-end pe-0 fs-5" xxl={2} sm={4}>
              ปีงบประมาณ
            </Label>
            <Col xxl={2} sm={8}>
              <Input
                type="select"
                defaultValue={selectedBudgedYear}
                onChange={(e) => {
                  setSelectedBudgedYear(e.target.value);
                }}
              >
                {budgedYearOptions?.map((item, idx) => {
                  return (
                    <option key={idx} value={item}>
                      {item}
                    </option>
                  );
                })}
              </Input>
            </Col> */}
          </Row>
        </Col>
      </Row>

      <Card style={{ minHeight: "450px", position: "relative" }}>
        <CardBody>
          <Row>
            <Col xxl={12}>
              {!isloading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "320px",
                  }}
                >
                  <LoadingData />
                </div>
              ) : (
                <FadeIn>
                  {entryPagination?.totalRows > 0 ? (
                    <div style={{ overflowX: "scroll" }}>
                      <Table striped hover style={{ verticalAlign: "middle" }}>
                        <thead
                          className="table-primary"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          <tr>
                            <th
                              width="5%"
                              className="text-center"
                            >
                              วันที่{" "}
                              {sortCount?.date === 0 ? (
                                <>&nbsp;&nbsp;&nbsp;</>
                              ) : sortCount?.date === 1 ? (
                                <i class="fa-solid fa-down"></i>
                              ) : (
                                <i class="fa-solid fa-up"></i>
                              )}
                            </th>
                            <th width="20%" className="text-center">
                              เข้างาน
                            </th>
                            <th width="20%" className="text-center">
                              ออกงาน
                            </th>
                            {/* <th className="text-center">สถานะ</th> */}
                            <th className="text-center">รายละเอียด OT</th>
                            <th 
                            // width="50%"
                             className="text-center">หมายเหตุ</th>
                            <th className="text-center"></th>
                          </tr>
                        </thead>
                        <tbody
                          className="table-light"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {chunkEntry[entryPagination?.page - 1]?.map(
                            (item, idx) => {
                              const ScanDate = item?.scan_date?.split("T");
                              const dateEntry = `${ScanDate[0].split("-")[2]}-${
                                ScanDate[0].split("-")[1]
                              }-${ScanDate[0].split("-")[0]}`;
                              const time = ScanDate[1]?.split(".");
                              const timeEntry = time[0];

                              const match = outHistory?.filter((item2) => {
                                if (
                                  item2?.scan_date?.split("T")[0] ===
                                  item?.scan_date?.split("T")[0]
                                ) {
                                  return item2?.scan_date
                                    ?.split("T")[1]
                                    ?.split(".")[0];
                                }
                              });
                              let scanDate = match[0]?.scan_date
                                ?.split("T")[1]
                                ?.split(".")[0];

                              let note = item?.entry_exit_status === 4 ? item?.entry_exit_status_name : item?.note
                              if (note === '-') {
                                if (match[0]) {
                                  note = match[0]?.note
                                }
                              }
                              return (
                                <tr key={idx}>
                                  <td className="text-center">
                                    {ConvertDate(
                                      item?.scan_date?.split("T")[0]
                                    ).toThaiDateDMY()}
                                    {/* {item?.scan_date} */}
                                  </td>
                                  <td className="text-center">
                                    {(item?.entry_exit_status === 0 || item?.entry_exit_status === 5) && timeEntry !== "00:00:00"
                                      ? timeEntry + " น."
                                      : "-"}{" "}
                                  </td>
                                  <td className="text-center">
                                    {match[0]?.scan_date !== undefined
                                      ? scanDate + " น."
                                      : "-"}
                                  </td>
                                  {/* <td className="text-center">
                                    {match[0]?.scan_date !== undefined
                                      ? "ลงเวลากลับ"
                                      : "ขาดงาน"}{" "}
                                  </td> */}
                                  <td className="text-center text-truncate" style={{maxWidth : "150px"}} title={match[0]?.ot_remark ?? ""}>
                                  {match[0] ? (
                                  <>
                                    <i
                                      style={{
                                        cursor: "pointer"
                                      }}
                                      onClick={() => {
                                        setOTRemarkModal(true);
                                        setFscanID(match[0]?.fscan_id);
                                        match[0]?.ot_remark && setOTRemark(match[0]?.ot_remark);
                                        }}
                                      className="fa-solid fa-pen-to-square me-2"/>
                                    {match[0]?.ot_remark ?? ""}
                                  </>
                                  ) : ("-")
                                  }
                                  </td>
                                  <td className="text-center">{note}</td>
                                  <td className="text-center">
                                  {(timeEntry && timeEntry !== "00:00:00") && !scanDate && !(item.entry_exit_status === 5) ? (
                                      <Button
                                        color="danger"
                                        className="py-1"
                                        onClick={() => {
                                          navigate(
                                            "/leave?exitbefore=1&&formID=10"
                                          );
                                          setNavigateState(item.scan_date)
                                        }}
                                      >
                                        <i className="fa-solid fa-exclamation"></i>
                                      </Button>
                                    ) : null}
                                    {/* {match[0]?.scan_date !==
                                    undefined ? null : match &&
                                      item?.entry_exit_status ? null : (
                                      <Button
                                        color="danger"
                                        className="py-1"
                                        onClick={() => {
                                          navigate(
                                            "/leave?exitbefore=1&&formID=10"
                                          );
                                          setNavigateState(item.scan_date)
                                        }}
                                      >
                                        <i className="fa-solid fa-exclamation"></i>
                                      </Button>
                                    )} */}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "400px",
                      }}
                    >
                      <h3>ไม่มีรายการเข้างาน</h3>
                    </div>
                  )}
                </FadeIn>
              )}
            </Col>
          </Row>
        </CardBody>
        {entryHistory?.length > 0 && (
          <Row
            className="mx-2"
            style={{
              display: "flex",
              alignItems: "end",
            }}
          >
            <Col xxl={4} sm={3} xs={12} className="mb-2">
              <h4>
                <Badge className="badge-soft-primary me-1">
                  ทั้งหมด {entryPagination?.totalRows} รายการ
                </Badge>
              </h4>
            </Col>
            <Col xxl={8} sm={9} xs={12} className="d-flex justify-content-end">
              <Pagination aria-label="Page navigation example">
                <PaginationItem disabled={entryPagination?.page === 1}>
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({ ...prev, page: 1 }))
                    }
                  >
                    หน้าแรก
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={entryPagination?.page === 1}>
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({
                        ...prev,
                        page: prev.page - 1,
                      }))
                    }
                  >
                    ย้อนกลับ
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem active>
                  <PaginationLink>
                    หน้า {entryPagination?.page} จาก{" "}
                    {entryPagination?.totalPage}
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    entryPagination?.page === entryPagination?.totalPage
                  }
                >
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({
                        ...prev,
                        page: prev.page + 1,
                      }))
                    }
                  >
                    ถัดไป
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem
                  disabled={
                    entryPagination?.page === entryPagination?.totalPage
                  }
                >
                  <PaginationLink
                    onClick={() =>
                      setEntryPagination((prev) => ({
                        ...prev,
                        page: prev.totalPage,
                      }))
                    }
                  >
                    หน้าสุดท้าย
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </Col>
          </Row>
        )}
      </Card>
      <ConfirmModal
        modal = {OTRemarkModal}
        modalSize = {"md"}
        modalHeaderContent = {"แก้ไขรายละเอียดการทำ OT"}
        modalBodyContent = {
          <>
            <FormGroup className="mx-3">
              <Label>รายละเอียดการทำ OT</Label>
              <Input type="textarea" value={OTRemark} onChange={(e) => {setOTRemark(e.target.value)}}/>
            </FormGroup>
          </>
        }
        confirmBtnText = {"บันทึก"}
        cancelBtnText = {"ปิด"}
        onClickConfirmBtn = {async () => {
          await timeHistoryEdit(fscanID);
          await getEntryHistory();
          setOTRemarkModal(false);
        }}
        onClickCancelBtn = {() => {
          setOTRemarkModal(false)
          setOTRemark("")
        }}
      />
    </React.Fragment>
  );
};

export default TimeHistoryTable;
